import { render } from "./machineCamera.vue?vue&type=template&id=f60f50fe&scoped=true"
import script from "./machineCamera.vue?vue&type=script&lang=js"
export * from "./machineCamera.vue?vue&type=script&lang=js"

import "./machineCamera.vue?vue&type=style&index=0&id=f60f50fe&scoped=true&lang=css"

import exportComponent from "D:\\A_Projcets_Code\\mes-chunyu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60f50fe"]])

export default __exports__